import React, { useState, useEffect, Fragment } from 'react';

import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { gAPI_Orders_Voucher } from '../../../../../../constants/APIs';
import {
    DropdownMenu,
    DropdownItem, UncontrolledDropdown,
    DropdownToggle, Button, Row, Input, Card
} from 'reactstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../../../components/DatatablePagination';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import ConfirmModal from './forms/ConfirmModal';
const VoucherPayment = ({ loading, voucherList, showRedeem, handleBack, dropDown, voucherFilter, handleVoucherFilter,
    voucherId, LoadSearchOrderData, handleRedeemVoucher, handleDropDown, handleCreateVoucherButtonShow, handleVoucherPaymentsById, onstartDateChange, onEndDateChange, handleSubmit, orderList, handleSearchfilter }) => {
    const [isLoading, setIsLoading] = useState(loading);
    const [searchVocuher, setSearchVoucher] = useState([]);
    const [startDate, setStartDate] = useState(moment().subtract(15, 'days'));
    const [endDate, setEndDate] = useState(moment());
    const [confirmModal, setShowConfirmModal] = useState(false);
    const [voucherData, setVoucherData] = useState("");
    const dataTableColumns = [
        {
            Header: 'Payment Id',
            accessor: 'paymentid',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset', "width": "100px" }
        },
        {
            Header: 'Voucher',
            accessor: 'name',
            Cell: props => <p style={{ marginLeft: "15%", width: "150px" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Voucher#',
            accessor: 'voucherNumber',
            Cell: props => <p style={{ marginLeft: "15%", width: "120px" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Order#',
            accessor: 'orderNumber',
            Cell: props => <p style={{ marginLeft: "11%", "width": "120px" }}>{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Status',
            accessor: 'status',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset', "width": "100px" }
        },
        {
            Header: 'Retail Price',
            accessor: 'price',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.row._original.currency.toUpperCase()} {props.value} </p>,
            style: { 'whiteSpace': 'unset', "width": "100px" }
        },
        {
            Header: 'Chosen Option',
            accessor: 'optionName',
            Cell: props => <p style={{ marginLeft: "19%", width: "150px" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Discount',
            accessor: 'discount',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.value}%</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Discounted Price',
            accessor: 'discountedPrice',
            Cell: props => <p style={{ marginLeft: "19%", "width": "120px" }} >{props.row._original.currency.toUpperCase()} {props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'aiva Fee',
            accessor: 'processingFee',
            Cell: props => <p style={{ marginLeft: "19%", "width": "150px" }}>$ {(parseFloat(props.row._original.processingFee))}</p>,
            style: { 'whiteSpace': 'unset' }
        }
        , {
            Header: 'Gifted',
            accessor: 'gifted',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.row._original.gifted ? "Yes" : "No"}</p>,
            style: { 'whiteSpace': 'unset', }
        },
    ];
    if (!showRedeem) {
        dataTableColumns.push({
            Header: '',
            accessor: 'redeem',
            Cell: props => !props.value ? <div> <Button color="primary" size="xs" onClick={() => handleClick(props.row._original)}>Redeem Voucher</Button></div> : <div></div>,
            style: { 'whiteSpace': 'unset' }
        });
    } else {
        dataTableColumns.push({
            Header: 'Redeem Date',
            accessor: 'redeemDate',
            Cell: props => <p style={{ marginLeft: "19%" }} >{moment(props.value).format("DD-MM-YYYY hh:mm:ss A")}</p>,
            style: { 'whiteSpace': 'unset', "width": "100px" }
        });
    }
    const handleClick = (data) => {
        setSearchVoucher("");
        setShowConfirmModal(true);
        setVoucherData(data);

    };
    const handleChangeDate = date => {
        setStartDate(date);
        onstartDateChange(date);
    };
    const handleChangeEndDate = date => {
        setEndDate(date);
        onEndDateChange(date);
    };

    return (
        <Fragment>
            <Row className="col-md-12">
                <Colxx xxs="10" md="2" className="">
                    <a onClick={() => { handleBack(); handleCreateVoucherButtonShow(); }}>
                        <h1 class="iconsminds-back"></h1></a>
                </Colxx>
            </Row>
            <Row className="col-md-12">
                <Colxx xxs="2" md="2" className="mb-2">
                    <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                        {voucherList !== undefined && voucherList.length > 0 && (<DropdownToggle caret color="outline-dark" size="xs">
                            {dropDown}
                        </DropdownToggle>)}
                        <DropdownMenu>
                            {voucherList.length > 0 && (
                                voucherList.map((e) => {
                                    return (
                                        <Fragment>
                                            <DropdownItem
                                                key={e.id}
                                                value={e.id}
                                                onClick={(f) => {
                                                    handleDropDown(e.name);
                                                    handleVoucherPaymentsById(e.id);
                                                }}
                                            >        {e.name}
                                            </DropdownItem>
                                        </Fragment>
                                    );
                                }))}
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </Colxx>
            </Row>
            <Row className="col-md-12">
                <Colxx xxs="2" md="2" className="mb-2">
                    <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                        {voucherList !== undefined && voucherList.length > 0 && (<DropdownToggle caret color="outline-dark" size="xs">
                            {voucherFilter}
                        </DropdownToggle>)}
                        <DropdownMenu>
                            <DropdownItem
                                key="All"
                                value="All"
                                onClick={(f) => {
                                    handleVoucherFilter('All');
                                    handleVoucherPaymentsById(voucherId, 'All');
                                }}
                            >      All
                            </DropdownItem>

                            <DropdownItem
                                key="Active"
                                value="Active"
                                onClick={(f) => {
                                    handleVoucherFilter('Active');
                                    handleVoucherPaymentsById(voucherId, false);
                                }}
                            >      Active
                            </DropdownItem>
                            <DropdownItem
                                key="Redeemed"
                                value="Redeemed"
                                onClick={(f) => {
                                    handleVoucherFilter('Redeemed');
                                    handleVoucherPaymentsById(voucherId, true);
                                }}
                            >      Redeemed
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </Colxx>
            </Row>
            <Row className="col-md-12">
                <Colxx xxs="10" md="2" className="mb-2">
                    <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                        <Input value={searchVocuher} className="form-control input_sty" placeholder="Search" onChange={(e) => {
                            setSearchVoucher(e.target.value);
                            handleSearchfilter(e.target.value);
                        }}></Input>
                    </div>
                </Colxx>
            </Row>
            <br />
            <Row className="col-md-12">

                <Fragment>

                    <Colxx xxs="12" md="2" className="mb-2">
                        <DatePicker
                            selected={startDate ? new Date(startDate) : null} // ensure Date object
                            onChange={handleChangeDate}
                            placeholderText="Start Date"
                            dateFormat="dd/MM/yyyy"
                        />
                    </Colxx>
                    <Colxx xxs="12" md="2" className="mb-2">
                        <DatePicker
                            selected={endDate ? new Date(endDate) : null}
                            onChange={handleChangeEndDate}
                            placeholderText="End Date"
                            dateFormat="dd/MM/yyyy"
                        />
                    </Colxx>
                    <Colxx xxs="12" md="1" className="mb-2">
                        <Button
                            color="primary"
                            className="mb-2"
                            onClick={() => { setSearchVoucher(""); handleSubmit() }}
                        >
                            <IntlMessages id="forms.submit" />
                        </Button>
                    </Colxx>
                </Fragment>


            </Row >
            <Row className="col-md-12">
                <Colxx xxs="12">
                    <Card className="d-flex flex-row mb-3">
                        <Fragment>
                            <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                                {!isLoading && orderList ? (
                                    <ReactTable
                                        data={orderList}
                                        columns={dataTableColumns}
                                        defaultPageSize={10}
                                        filterable={false}
                                        showPageJump={true}
                                        PaginationComponent={DataTablePagination}
                                        showPageSizeOptions={true}
                                        className="-striped -highlight -bordered"

                                        style={{ width: "100%" }}
                                    />
                                ) : ""
                                }
                            </div>
                        </Fragment>
                    </Card>
                </Colxx>
            </Row>
            <ConfirmModal
                showModal={confirmModal}
                hideModal={() => {
                    setShowConfirmModal(false);
                }}
                voucherdata={voucherData}
                handleRedeemVoucher={handleRedeemVoucher}
            />
        </Fragment >
    );
};

export default VoucherPayment;
